export const getMarketplaceUrls = () => {
  if (process.env.REACT_APP_MARKETPLACE_URLS) {
    return process.env.REACT_APP_MARKETPLACE_URLS.replaceAll('[', '').replaceAll(']', '').replaceAll('"', '').replaceAll("'", '').replaceAll(' ', '').split(',')
  }
  return [];
}